import clearStateEnhance from "core/store/enhancers/clearStateEnhance";
import { combineReducers, Reducer } from "redux";
import { reducer as formReducer } from "redux-form";
import { createTransform } from "redux-persist";
import loginReducer, {
  model as loginModel,
  persist as loginPersist,
} from "./login";
import registerReducer, { model as registerModel } from "./register";
import { IState as MainState, reducer as mainReducer } from "./main";
import persistReducer, { model as persistModel } from "./persist";
import reviewersReducer, { model as reviewersModel } from "./reviewers";
import * as actionTypes from "./technicians/actionTypes";
import { model as reviewerModel } from "./reviewers";
import techniciansReducer, { model as technicianModel } from "./technicians";

export interface IState {
  main: MainState;
  login: loginModel.IState;
  register: registerModel.IState;
  persist: persistModel.IState;
  reviewers: reviewerModel.IState;
  technicians: technicianModel.IState;
}

const reducer: Reducer<IState> = combineReducers<IState>({
  login: clearStateEnhance(loginReducer),
  register: clearStateEnhance(registerReducer),
  form: clearStateEnhance(
    formReducer.plugin({
      inviteTechniciansForm: (state, action) => {
        switch (action.type) {
          case actionTypes.ADD_TECHNICIANS: {
            return undefined; // remove all form state
          }
          default:
            return state;
        }
      },
    })
  ),
  main: mainReducer,
  persist: persistReducer,
  reviewers: clearStateEnhance(reviewersReducer),
  technicians: clearStateEnhance(techniciansReducer),
});
export default reducer;

export const persistReducerKeys = ["login"];

export const transforms = [
  createTransform<loginModel.IState, loginPersist.IPersistState>(
    (inboundState) => loginPersist.persistState(inboundState),
    (outboundState) => loginPersist.hydrateState(outboundState),
    { whitelist: ["login"] }
  ),
];



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/reducer.ts